import { render, staticRenderFns } from "./LoanHistoryTab.vue?vue&type=template&id=a22837e4&scoped=true"
import script from "./LoanHistoryTab.vue?vue&type=script&lang=js"
export * from "./LoanHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./LoanHistoryTab.vue?vue&type=style&index=0&id=a22837e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22837e4",
  null
  
)

export default component.exports